import React from "react";
import { useLoader } from "../context/LoaderContext";
import { hideLoader, showLoader } from "../utils/loader";

export default function GlobalLoader() {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div id="initial-loader">
    <div className="loader-content">
      <div className="loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <p>Loading...</p>
    </div>
    </div>
  );
}